import { getCookies } from "../shared";

export default async function api(url, method = "GET", params) {
  const csrftoken = getCookies("csrftoken");
  const Options = {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": csrftoken
    }
  };
  if (params) {
    if (method === "GET") {
      url.search = new URLSearchParams(params);
    } else {
      Options.body = JSON.stringify(params);
    }
  }
  return fetch(url, Options).then(async (response) => {
    if (!response.ok)
      return response.json().then((data) => {
        return { errors: data };
      });
    return response.json();
  });
}
